import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SchoolTypeApi } from '../+api';
import { SchoolTypeInterface } from '../+models';
import { SchoolTypeServiceInterface } from './school-type.service.interface';

@Injectable({
  providedIn: 'root',
})
export class SchoolTypeService implements SchoolTypeServiceInterface {
  private schoolTypeApi = inject(SchoolTypeApi);

  constructor() {}

  getAll(): Observable<SchoolTypeInterface[]> {
    return this.schoolTypeApi.find();
  }

  getSchoolTypes$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: SchoolTypeInterface[]; count: number }> {
    const params = new HttpParams({
      fromObject: {
        searchTerm: searchTerm || '',
        filters: JSON.stringify(filters || {}),
        columns: JSON.stringify(columns || null),
        sorting: JSON.stringify(sorting || {}),
        pagination: JSON.stringify(pagination || {}),
      },
    });
    return this.schoolTypeApi.getSchoolTypes(params);
  }

  deleteSchoolType$(id: number): Observable<boolean> {
    return this.schoolTypeApi.deleteById(id);
  }

  createSchoolType(schoolType: SchoolTypeInterface): Observable<SchoolTypeInterface> {
    return this.schoolTypeApi.createSchoolType(schoolType);
  }

  updateSchoolType(schoolType: SchoolTypeInterface): Observable<SchoolTypeInterface> {
    const params = new HttpParams({
      fromObject: {
        id: schoolType.id?.toString(),
      },
    });
    return this.schoolTypeApi.updateSchoolType(params, schoolType);
  }
}
